// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/BuildingsList/BuildingsList.scss
// module id = 730
// module chunks = 0